export class Base64BlobUtils {

    /**
     * Data la stringa base64 che rappresenta il contenuto di un file
     * viene ritornato il blob corrispondente
     * @param base64 contenuto di un file
     * @param mimeType mime type associato al file
     */
    static async base64ToBlob(base64: string, mimeType: string): Promise<Blob> {
        const binary = await fetch('data:' + mimeType + ';base64,' + base64, {
            method: 'GET'
        });
        return binary.blob();
    }
}